/* eslint-disable react/self-closing-comp */
/* eslint-disable react/prop-types */
import React from 'react';
import { useDispatch } from 'react-redux';
import { Table, Grid, Button, Segment, Image, Label } from 'semantic-ui-react';
import { openModal } from '../../../redux/modals/modalReducer';

const ComplaintViewAdmin = ({ complaint, userList }) => {
  const dispatch = useDispatch();

  return (
    <>
      <Grid>
        <Grid.Column width={8}>
          <Segment.Group>
            <Segment className="ui green">
              <Table fixed>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Etat</Table.HeaderCell>

                    <Table.HeaderCell></Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  <Table.Row>
                    <Table.Cell>{complaint.statut}</Table.Cell>

                    <Table.Cell>
                      {' '}
                      <Button
                        basic
                        color="blue"
                        onClick={() =>
                          dispatch(
                            openModal({
                              modalType: 'ModalComplaintStatut',
                              modalProps: { complaint }
                            })
                          )
                        }
                      >
                        Modifier le statut
                      </Button>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Segment>
          </Segment.Group>
        </Grid.Column>
        <Grid.Column width={8}>
          <Segment.Group>
            <Segment className="ui green">
              <Table fixed>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Responsable de la plainte</Table.HeaderCell>

                    <Table.HeaderCell></Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  <Table.Row>
                    <Table.Cell>
                      <Label as="a">
                        <Image
                          avatar
                          spaced="right"
                          src="https://react.semantic-ui.com/images/avatar/small/elliot.jpg"
                        />
                        {complaint.responsable}
                      </Label>
                    </Table.Cell>

                    <Table.Cell>
                      <Button
                        basic
                        color="blue"
                        onClick={() =>
                          dispatch(
                            openModal({
                              modalType: 'ModalComplaintResponsable',
                              modalProps: { complaint, userList }
                            })
                          )
                        }
                      >
                        Affecter
                      </Button>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Segment>
          </Segment.Group>
        </Grid.Column>
      </Grid>
    </>
  );
};

export default ComplaintViewAdmin;
